module.exports = __webpack_public_path__ + "static/the-hidden-family-931f67a2f02f9e589260678d1b0ea803.jpg";